module.exports = __webpack_public_path__ + "static/media/Imaryuk2 copy.f1dad7d0.jpg";